<template>
    <Breadcrumb style="color: #28EDF8; margin-top: 20px">
      <BreadcrumbItem style="color: #28EDF8;"
        v-for="item in breadCrumbList"
        :href="item.path"
        :key="item.name"
      >
          <Icon v-if="item.path == '/index'" :size="17" style="position:relative;top:-2px" type="ios-home-outline"></Icon>
          {{item.meta.title}}
      </BreadcrumbItem>
    </Breadcrumb>
</template>

<script>
export default {
  name: "breadBar",
  props: {
      breadCrumbList: Array
  },
  methods: {

  }
};
</script>
